import { ExportIntegrationStatus, ExportItem } from '@aibees/elephant/hooks';
import { Icon, PopoverListButtonItem } from '@aibees/shared/components';
import { Avatar } from '@mui/material';
import { ExportTableActionType as Action } from './types';

export const getExportActionMenuItemsOptions = (item: ExportItem) =>
  [
    {
      label: 'Edit Name',
      key: Action.edit,
      icon: <Icon name="edit-outline" size={18} color="primary.500" />,
    },
    {
      label: 'Copy ID',
      key: Action.copyID,
      icon: <Icon name="badge-outline" size={18} color="primary.500" />,
    },
    {
      label: 'View Records',
      key: Action.view,
      icon: <Icon name="eye-outlined" size={18} color="primary.500" />,
    },
    ...(item.integrations
      ? [
          {
            label: 'View Campaign',
            key: Action.viewCampaign,
            icon: <Avatar src="/assets/images/Smartlead.jpg" size={16} />,
          },
        ]
      : []),
    ...(item.integrations &&
    item.integrations.SMART_LEAD?.status === ExportIntegrationStatus.FAILED
      ? [
          {
            label: 'Retry',
            key: Action.retry,
            icon: <Icon name="reload" size={18} color="primary.500" />,
          },
        ]
      : []),
    ...(item.integrations &&
    item.integrations.SMART_LEAD?.status === ExportIntegrationStatus.FAILED
      ? [
          {
            label: 'Download CSV',
            key: Action.downloadCSV,
            icon: (
              <Icon name="file-csv-outline" size={18} color="primary.500" />
            ),
          },
        ]
      : []),
  ] as PopoverListButtonItem[];
